import * as React from "react";
import PropTypes from 'prop-types';

const SvgHeartfill = props => {
  if (props.id !== "_svgheartfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 30 30" {...props}><path d="M19.3 6.6c-2.6 0-4.4 2.7-4.4 2.7s-1.7-2.7-4.4-2.7c-1.3 0-2.7.6-3.7 1.6-1.2 1.3-2 2.9-2.1 4.8 0 1.8.8 3.6 1.9 4.9l7 7.5c.4.4.8.7 1.2.7s1-.4 1.4-.7l7-7.5c1.2-1.3 1.8-3 1.8-4.8 0-1.8-.8-3.5-2-4.8-.9-1.1-2.4-1.7-3.7-1.7" fill="#e71324" fillRule="evenodd" /></svg>;
};

SvgHeartfill.displayName = "_svgheartfill";
SvgHeartfill.propTypes = {
  id: PropTypes.string
};
SvgHeartfill.defaultProps = {
  id: ''
};
export default SvgHeartfill;